// @generated by rtk-query-codegen -- DO NOT EDIT
import { baseApi as api } from "../client/baseApi";
import type { ColumnInput, ETLErrorCategory, ETLErrorConnector, ETLErrorInfo, ETLErrorReason, ETLErrorRemediation, ETLPayload, ETLSourceInput, SourceData, SourceFile, TableDescriptionDiff } from "../etlTasks/domain.generated";
import type { ColumnLineageHop, ColumnTypeChange, DownstreamImpact, DownstreamTable, ETLTaskChainResponse, ETLTaskResponse, EngineCheck, ImpactReason, JoinPartner, ListETLTaskChainsResponse, ListETLTasksResponse, ReviseSilverQueryResult, TableCodeResponse } from "../etlTasks/dto.generated";
import type { FailedTable, TableNeedingReview } from "../goldRefreshHealth/domain.generated";
export const addTagTypes = ["etl-tasks", "tables"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getApiProjectsByProjectIdEtlTaskChains: build.query<
        GetApiProjectsByProjectIdEtlTaskChainsApiResponse,
        GetApiProjectsByProjectIdEtlTaskChainsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/etl-task-chains`,
          params: {
            status: queryArg.status,
            since: queryArg.since,
            until: queryArg.until,
            correlation_id: queryArg.correlationId,
            usecase_id: queryArg.usecaseId,
            limit: queryArg.limit,
            cursor: queryArg.cursor,
          },
        }),
        providesTags: ["etl-tasks"],
      }),
      getApiProjectsByProjectIdEtlTasks: build.query<
        GetApiProjectsByProjectIdEtlTasksApiResponse,
        GetApiProjectsByProjectIdEtlTasksApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/etl-tasks`,
          params: {
            chain_id: queryArg.chainId,
            status: queryArg.status,
            correlation_id: queryArg.correlationId,
            usecase_id: queryArg.usecaseId,
            task_id: queryArg.taskId,
            limit: queryArg.limit,
            cursor: queryArg.cursor,
          },
        }),
        providesTags: ["etl-tasks"],
      }),
      deleteApiProjectsByProjectIdEtlCancel: build.mutation<
        DeleteApiProjectsByProjectIdEtlCancelApiResponse,
        DeleteApiProjectsByProjectIdEtlCancelApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/etl/cancel`,
          method: "DELETE",
        }),
        invalidatesTags: ["etl-tasks"],
      }),
      deleteApiProjectsByProjectIdEtlSourcesAndSourceIdCancel: build.mutation<
        DeleteApiProjectsByProjectIdEtlSourcesAndSourceIdCancelApiResponse,
        DeleteApiProjectsByProjectIdEtlSourcesAndSourceIdCancelApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/etl/sources/${encodeURIComponent(String(queryArg.sourceId))}/cancel`,
          method: "DELETE",
        }),
        invalidatesTags: ["etl-tasks"],
      }),
      getApiProjectsByProjectIdTablesAndTableNameCode: build.query<
        GetApiProjectsByProjectIdTablesAndTableNameCodeApiResponse,
        GetApiProjectsByProjectIdTablesAndTableNameCodeApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/tables/${encodeURIComponent(String(queryArg.tableName))}/code`,
        }),
        providesTags: ["tables"],
      }),
      postApiProjectsByProjectIdTablesAndTableNameRevise: build.mutation<
        PostApiProjectsByProjectIdTablesAndTableNameReviseApiResponse,
        PostApiProjectsByProjectIdTablesAndTableNameReviseApiArg
      >({
        query: (queryArg) => ({
          url: `/api/projects/${encodeURIComponent(String(queryArg.projectId))}/tables/${encodeURIComponent(String(queryArg.tableName))}/revise`,
          method: "POST",
          body: queryArg.etlTasksReviseSilverQueryRequest,
        }),
        invalidatesTags: ["tables"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as etlTasksApi };
export type GetApiProjectsByProjectIdEtlTaskChainsApiResponse =
  /** status 200 OK */ { data: EtlTasksListEtlTaskChainsResponse };
export type GetApiProjectsByProjectIdEtlTaskChainsApiArg = {
  /** Project ID */
  projectId: string;
  /** Chain status filter (SUCCESS, FAILED) */
  status?: string;
  /** Only chains created at or after this RFC3339 timestamp */
  since?: string;
  /** Only chains created at or before this RFC3339 timestamp */
  until?: string;
  /** Correlation ID filter */
  correlationId?: string;
  /** Usecase ID filter */
  usecaseId?: string;
  /** Maximum number of items to return (default: 20, max: 100) */
  limit?: number;
  /** Pagination cursor */
  cursor?: string;
};
export type GetApiProjectsByProjectIdEtlTasksApiResponse =
  /** status 200 OK */ { data: EtlTasksListEtlTasksResponse };
export type GetApiProjectsByProjectIdEtlTasksApiArg = {
  /** Project ID */
  projectId: string;
  /** Chain ID filter */
  chainId?: string;
  /** Task status filter (SUCCESS, FAILURE, RETRY, PENDING, RUNNING) */
  status?: string;
  /** Correlation ID filter */
  correlationId?: string;
  /** Usecase ID filter */
  usecaseId?: string;
  /** Task ID filter (Celery task ID) */
  taskId?: string;
  /** Maximum number of items to return (default: 20, max: 100) */
  limit?: number;
  /** Pagination cursor */
  cursor?: string;
};
export type DeleteApiProjectsByProjectIdEtlCancelApiResponse = unknown;
export type DeleteApiProjectsByProjectIdEtlCancelApiArg = {
  /** Project ID */
  projectId: string;
};
export type DeleteApiProjectsByProjectIdEtlSourcesAndSourceIdCancelApiResponse =
  unknown;
export type DeleteApiProjectsByProjectIdEtlSourcesAndSourceIdCancelApiArg = {
  /** Project ID */
  projectId: string;
  /** ETL Source ID */
  sourceId: string;
};
export type GetApiProjectsByProjectIdTablesAndTableNameCodeApiResponse =
  /** status 200 OK */ { data: EtlTasksTableCodeResponse };
export type GetApiProjectsByProjectIdTablesAndTableNameCodeApiArg = {
  /** Project ID */
  projectId: string;
  /** Table name */
  tableName: string;
};
export type PostApiProjectsByProjectIdTablesAndTableNameReviseApiResponse =
  /** status 200 OK */ { data: EtlTasksReviseSilverQueryResult };
export type PostApiProjectsByProjectIdTablesAndTableNameReviseApiArg = {
  /** Project ID */
  projectId: string;
  /** Table name */
  tableName: string;
  /** Corrected SQL */
  etlTasksReviseSilverQueryRequest: EtlTasksReviseSilverQueryRequest;
};
export type DomainEtlErrorCategory = ETLErrorCategory;
export type DomainEtlErrorConnector = ETLErrorConnector;
export type DomainEtlErrorReason = ETLErrorReason;
export type DomainEtlErrorRemediation = ETLErrorRemediation;
export type DomainEtlErrorInfo = ETLErrorInfo;
export type EtlTasksEtlTaskChainResponse = ETLTaskChainResponse;
export type EtlTasksListEtlTaskChainsResponse = ListETLTaskChainsResponse;
export type DomainSourceFile = SourceFile;
export type DomainSourceData = SourceData;
export type DomainAuditColumn = {
  change?: string;
  column?: string;
  reason?: string;
};
export type DomainAuditReport = {
  columns?: DomainAuditColumn[];
};
export type DomainColumnDescription = {
  description?: string;
  name?: string;
  table_id?: string;
  type?: string;
};
export type DomainForeignKeyDescription = {
  constrained_columns?: string[];
  referred_columns?: string[];
  referred_table?: string;
};
export type DomainSapHeaderDeltaConfig = {
  documents_per_call?: number;
  header_table?: string;
  header_where_clause?: string;
  link_columns?: string[];
  max_documents?: number;
  /** MaxTableRatio refuses a run whose projected read reaches this share of the rows bronze holds.
    A pointer because 0 disables the check and absent means auto-etl's 1.0. */
  max_table_ratio?: number;
};
export type DomainWindowReloadConfig = {
  column?: string;
  from?: string;
  /** MinRatio refuses a window that comes back under this fraction of the rows it replaces. A
    pointer because 0 is meaningful (it disables the guard) and absent means auto-etl's 0.5. */
  min_ratio?: number;
  to?: string;
};
export type DomainIncrementalConfig = {
  created_column?: string;
  deleted_column?: string;
  /** FullLoadMinRatio rolls back a full load that lands under this share of the rows it replaces.
    Carried whatever else is set, since any table can resolve to a full load; a pointer because 0
    disables the guard and absent means auto-etl's 0.5. */
  full_load_min_ratio?: number;
  /** Set instead of UpdateColumn when the delta comes from a header table. Nested here rather than
    sitting beside Incremental because MergeKey is genuinely shared by every merge profile — this
    says only *how the delta is found*, not whether the table merges. */
  header_delta?: DomainSapHeaderDeltaConfig;
  lookback_minutes?: number;
  merge_key?: string;
  update_column?: string;
  /** Set instead of MergeKey/UpdateColumn: a window reload merges nothing, so it names no key. It
    lives on this struct despite the name because this is the one home for "how this table is
    loaded" — the struct predates the profile taxonomy, and a sibling field on TableDescription
    would give a table two places to answer the same question. */
  window?: DomainWindowReloadConfig;
};
export type DomainTableDescription = {
  audit_report?: DomainAuditReport;
  code?: string;
  columns?: DomainColumnDescription[];
  description?: string;
  foreign_keys?: DomainForeignKeyDescription[];
  incremental?: DomainIncrementalConfig;
  /** IsCoOwned marks a shared table this project co-owns: its members manage the source that
    loads it, from the provider's routes. */
  is_co_owned?: boolean;
  is_shared?: boolean;
  layer_id?: string;
  name?: string;
  not_null_columns?: string[];
  primary_keys?: string[];
  provider_database?: string;
  provider_project_name?: string;
  unique_columns?: string[];
};
export type DomainEtlSourceInput = ETLSourceInput;
export type DomainColumnInput = ColumnInput;
export type DomainTableDescriptionDiff = TableDescriptionDiff;
export type DomainFailedTable = FailedTable;
export type DomainTableNeedingReview = TableNeedingReview;
export type DomainEtlPayload = ETLPayload;
export type EtlTasksEtlTaskResponse = ETLTaskResponse;
export type EtlTasksListEtlTasksResponse = ListETLTasksResponse;
export type EtlTasksTableCodeResponse = TableCodeResponse;
export type EtlTasksJoinPartner = JoinPartner;
export type EtlTasksColumnLineageHop = ColumnLineageHop;
export type EtlTasksColumnTypeChange = ColumnTypeChange;
export type EtlTasksEngineCheck = EngineCheck;
export type EtlTasksImpactReason = ImpactReason;
export type EtlTasksDownstreamImpact = DownstreamImpact;
export type EtlTasksDownstreamTable = DownstreamTable;
export type EtlTasksReviseSilverQueryResult = ReviseSilverQueryResult;
export type EtlTasksReviseSilverQueryRequest = {
  code?: string;
  reasoning?: string;
  validate_only?: boolean;
};
export const {
  useGetApiProjectsByProjectIdEtlTaskChainsQuery,
  useLazyGetApiProjectsByProjectIdEtlTaskChainsQuery,
  useGetApiProjectsByProjectIdEtlTasksQuery,
  useLazyGetApiProjectsByProjectIdEtlTasksQuery,
  useDeleteApiProjectsByProjectIdEtlCancelMutation,
  useDeleteApiProjectsByProjectIdEtlSourcesAndSourceIdCancelMutation,
  useGetApiProjectsByProjectIdTablesAndTableNameCodeQuery,
  useLazyGetApiProjectsByProjectIdTablesAndTableNameCodeQuery,
  usePostApiProjectsByProjectIdTablesAndTableNameReviseMutation,
} = injectedRtkApi;
